import React, { Component } from 'react';

import FaSkype from 'react-icons/lib/fa/skype';
import wizy from '../../assets/images/wizy.svg';

import './footer.scss';


export default class Footer extends Component {
  render() {
    return (
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <img className="logo" alt="" src={wizy} />
              <p className="info-company">® 2020 Wizy Technology. All Rights Reserved</p>
              <p>Version 3.0.0</p>
            </div>
            <div className="col-md-3">
              <p className="title-footer">Office Address</p>
              <p>Topaz Building, 04 Trinh Dinh Thao, Hoa Thanh Ward, Tan Phu District, HCM City, Vietnam</p>
            </div>
            <div className="col-md-3">
              <p className="title-footer">Contact Information</p>
              <p className="contact" onClick={() => { window.location.href = 'tel:‭+84823881011' }}>
                ‭(+84) 0823.88.1011
              </p>
              <p className="contact" onClick={() => { window.location.href = 'mailto:info@wizy.vn' }}>
                info@wizy.vn
              </p>

            </div>
            <div className="col-md-2">
              <p className="title-footer message">Instant Messenging</p>
              <button className="btn">
                <a href="skype:live:info_680348?chat"><span><h4><FaSkype /></h4>Skype</span></a>
              </button>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js